import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from "./authentication.service";

@Injectable({
	providedIn: 'root'
})
export class RoleGuard implements CanActivate {

	constructor(private router: Router, private authService: AuthenticationService) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const userRoles = route.data['roles'] as Array<string>;

		for (const role of userRoles) {
			if (this.authService.isLoggedUserWithRole(role)) {
				return true;
			}
		}

		this.router.navigate(['login']);
		return false;
	}

}
